module.exports = __webpack_public_path__ + "media/devoted.d52c8cde.mp3";